import { IDexTrade } from '@kattana-io/common';
import { formatTimestamp } from '../../../DexTrades/formatters';
import { formatWallet } from '../formatters';
import {
  formatMobileTableData,
  IMobileTableScema,
} from '../../../../helpers/formatters';
import BodyTableMobile from '../../ModalTable/mobile/BodyTable';
import { ITradesTableProps } from '../TradesTable';
import { onTxScan } from '../../../../helpers/addressUtils';
import NumberDisplay from '../../../../molecules/NumberDisplay';
import { contentColors } from '../../../../molecules/Table/mobile/TableCard';

const getColorForItem = (
  rowData: IDexTrade | undefined,
  accessor: string
): contentColors => {
  if (accessor === 'price_a_usd' && rowData) {
    if (rowData.buy) {
      return 'green';
    }
    return 'red';
  }
  return 'grey';
};

const TradesTableMobile = (props: ITradesTableProps) => {
  const { base, quote, trades, base_decimals, quote_decimals, flipped } = props;

  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Date',
        accessor: 'timestamp',
        parser: (value) => formatTimestamp(value, props.timezone),
        width: 150,
      },
      item_2: {
        name: 'Price USD',
        accessor: 'price_a_usd',
        parser: (value) => (
          <NumberDisplay value={value} startSymbol='$' string />
        ),
        string: true,
      },
    },
    row_2: {
      item_1: {
        name: `(${quote})`,
        accessor: 'price_a',
        parser: (value) => (
          <NumberDisplay value={value} startSymbol='(' endSymbol=')' string />
        ),
        width: 150,
        string: true,
      },
      item_2: {
        name: `Amount ${base}`,
        accessor: flipped ? 'amount1' : 'amount0',
        parser: (value) => (
          <NumberDisplay value={Number(value) / 10 ** base_decimals} string />
        ),
        string: true,
      },
    },
    row_3: {
      item_1: {
        name: `Total ${quote}`,
        accessor: flipped ? 'amount0' : 'amount1',
        parser: (value) => (
          <NumberDisplay value={Number(value) / 10 ** quote_decimals} string />
        ),
        width: 150,
        string: true,
      },
      item_2: {
        name: 'Txn Value (USD)',
        accessor: 'value_usd',
        parser: (value) => (
          <NumberDisplay value={Number(value)} startSymbol='$' string />
        ),
        string: true,
      },
    },
    row_4: {
      item_1: {
        name: 'Txn Hash',
        accessor: 'tx',
        parser: (value) => `${formatWallet(value)}`,
        onClick: (row) => onTxScan(row.tx, props.chain),
        color: 'navy',
      },
    },
  };

  const parsedData = formatMobileTableData({
    data: trades,
    schema,
    getColorForItem,
  });

  return <BodyTableMobile data={parsedData} schema={schema} />;
};

export default TradesTableMobile;
